import moment from 'moment';

export const timeToString = (value: Date | string | number) => {
  return moment(value).format('HH:mm').toString();
};
